export const tamilFlashcards = {
  categories: [
    {
      ta: "வணக்கம்",
      rm: "Vaṇakkam",
      en: "Hello / Greetings",
    },
    {
      ta: "எப்படி இருக்கீங்க?",
      rm: "Eppadi irukkeenga?",
      en: "How are you? (formal)",
    },
    {
      ta: "எப்படி இருக்க?",
      rm: "Eppadi irukka?",
      en: "How are you? (informal)",
    },
    {
      ta: "நான் நல்லா இருக்கேன்",
      rm: "Naan nalla irukken",
      en: "I am fine",
    },
    {
      ta: "நன்றி",
      rm: "Nandri",
      en: "Thank you",
    },
    {
      ta: "ரொம்ப நன்றி",
      rm: "Romba nandri",
      en: "Thank you very much",
    },
    {
      ta: "பரவாயில்லை",
      rm: "Paravaayillai",
      en: "You're welcome / It's okay / Never mind",
    },
    {
      ta: "சாரி",
      rm: "Saari",
      en: "Sorry",
    },
    {
      ta: "மன்னிக்கவும்",
      rm: "Mannikkavum",
      en: "Excuse me / Forgive me (formal)",
    },
    {
      ta: "தயவு செஞ்சு",
      rm: "Dayavu senju",
      en: "Please",
    },
    {
      ta: "ஆமா",
      rm: "Aamaa",
      en: "Yes",
    },
    {
      ta: "இல்ல",
      rm: "Illa",
      en: "No",
    },
    {
      ta: "சரி",
      rm: "Sari",
      en: "Okay / Alright",
    },
    {
      ta: "எனக்குப் புரியல",
      rm: "Enakku puriyala",
      en: "I don't understand",
    },
    {
      ta: "உங்களுக்கு ஆங்கிலம் தெரியுமா?",
      rm: "Ungalukku aangilam theriyumaa?",
      en: "Do you know English?",
    },
    {
      ta: "இது என்ன?",
      rm: "Idhu enna?",
      en: "What is this?",
    },
    {
      ta: "இது எவ்வளோ?",
      rm: "Idhu evvolo?",
      en: "How much is this?",
    },
    {
      ta: "எங்க இருக்கு?",
      rm: "Enga irukku?",
      en: "Where is...?",
    },
    {
      ta: "டாய்லெட் எங்க இருக்கு?",
      rm: "Toilet enga irukku?",
      en: "Where is the toilet?",
    },
    {
      ta: "ரயில் நிலையம் எங்க இருக்கு?",
      rm: "Rail nilayam enga irukku?",
      en: "Where is the railway station?",
    },
    {
      ta: "விமான நிலையம் எங்க இருக்கு?",
      rm: "Vimaana nilayam enga irukku?",
      en: "Where is the airport?",
    },
    {
      ta: "மருத்துவமனை எங்க இருக்கு?",
      rm: "Maruththuvamanai enga irukku?",
      en: "Where is the hospital?",
    },
    {
      ta: "உதவி பண்ணுங்க!",
      rm: "Udhavi pannunga!",
      en: "Help!",
    },
    {
      ta: "போலீஸ்!",
      rm: "Police!",
      en: "Police!",
    },
    {
      ta: "எனக்கு உதவி தேவை",
      rm: "Enakku udhavi thevai",
      en: "I need help",
    },
    {
      ta: "நான் தொலைஞ்சுட்டேன்",
      rm: "Naan tholainjutten",
      en: "I am lost",
    },
    {
      ta: "நீங்க எனக்கு உதவி செய்ய முடியுமா?",
      rm: "Neenga enakku udhavi seiyya mudiyumaa?",
      en: "Can you help me?",
    },
    {
      ta: "மெதுவா பேசுங்க",
      rm: "Medhuvaa pesunga",
      en: "Speak slowly",
    },
    {
      ta: "மறுபடியும் சொல்லுங்க",
      rm: "Marupadiyum sollunga",
      en: "Say it again",
    },
    {
      ta: "நான் உடம்பு சரியில்லாம இருக்கேன்",
      rm: "Naan udambu sariyillaama irukken",
      en: "I am sick",
    },
    {
      ta: "எனக்கு டாக்டர் தேவை",
      rm: "Enakku doctor thevai",
      en: "I need a doctor",
    },
    {
      ta: "இது ரொம்ப விலை அதிகமா இருக்கு",
      rm: "Idhu romba vilai adhikkamaa irukku",
      en: "This is too expensive",
    },
    {
      ta: "கொஞ்சம் குறைக்க முடியுமா?",
      rm: "Konjam kuraikka mudiyumaa?",
      en: "Can you lower the price?",
    },
    {
      ta: "எனக்கு இது வேணும்",
      rm: "Enakku idhu venum",
      en: "I want this",
    },
    {
      ta: "எனக்கு இது வேணாம்",
      rm: "Enakku idhu venaam",
      en: "I don't want this",
    },
    {
      ta: "என் பேரு...",
      rm: "En peru...",
      en: "My name is...",
    },
    {
      ta: "நீங்க எப்படி இருக்கீங்க?",
      rm: "Neenga eppadi irukkeenga?",
      en: "How are you? (formal)",
    },
    {
      ta: "என்ன விஷயம்?",
      rm: "Enna vishayam?",
      en: "What's up? (informal)",
    },
    {
      ta: "எப்படி போகுது?",
      rm: "Eppadi poguthu?",
      en: "How's it going?",
    },
    {
      ta: "நான் நல்லா இருக்கேன், நன்றி",
      rm: "Naan nalla irukken, nandri",
      en: "I am fine, thank you",
    },
    {
      ta: "நல்லா இருக்கு",
      rm: "Nalla irukku",
      en: "Good / It's good",
    },
    {
      ta: "ரொம்ப நல்லா இருக்கு",
      rm: "Romba nalla irukku",
      en: "Very good",
    },
    {
      ta: "மோசமா இருக்கு",
      rm: "Mosamaa irukku",
      en: "It's bad",
    },
    {
      ta: "காலை வணக்கம்",
      rm: "Kaalai vaṇakkam",
      en: "Good morning",
    },
    {
      ta: "மதியம் வணக்கம்",
      rm: "Mathiyam vaṇakkam",
      en: "Good afternoon",
    },
    {
      ta: "மாலை வணக்கம்",
      rm: "Maalai vaṇakkam",
      en: "Good evening",
    },
    {
      ta: "இரவு வணக்கம்",
      rm: "Iravu vaṇakkam",
      en: "Good night",
    },
    {
      ta: "போயிட்டு வாங்க",
      rm: "Poittu vaanga",
      en: "Goodbye",
    },
    {
      ta: "பார்க்கலாம்",
      rm: "Paarkkalaam",
      en: "See you",
    },
    {
      ta: "வலது",
      rm: "Valathu",
      en: "Right",
    },
    {
      ta: "இடது",
      rm: "Idathu",
      en: "Left",
    },
    {
      ta: "நேரா",
      rm: "Neraa",
      en: "Straight",
    },
    {
      ta: "மேலே",
      rm: "Mele",
      en: "Up",
    },
    {
      ta: "கீழே",
      rm: "Keezhe",
      en: "Down",
    },
    {
      ta: "பக்கத்துல",
      rm: "Pakkaththula",
      en: "Near",
    },
    {
      ta: "தூரத்துல",
      rm: "Thooraththula",
      en: "Far",
    },
    {
      ta: "இன்று",
      rm: "Indru",
      en: "Today",
    },
    {
      ta: "நாளைக்கு",
      rm: "Naalaikku",
      en: "Tomorrow",
    },
    {
      ta: "நேற்று",
      rm: "Netru",
      en: "Yesterday",
    },
    {
      ta: "இப்போ",
      rm: "Ippo",
      en: "Now",
    },
    {
      ta: "அப்புறம்",
      rm: "Appuram",
      en: "Later",
    },
    {
      ta: "காலையில",
      rm: "Kaalaiyila",
      en: "In the morning",
    },
    {
      ta: "மதியத்துல",
      rm: "Mathiyaththula",
      en: "In the afternoon",
    },
    {
      ta: "சாயங்காலம்",
      rm: "Saayangaalam",
      en: "In the evening",
    },
    {
      ta: "ராத்திரி",
      rm: "Raaththiri",
      en: "At night",
    },
    {
      ta: "தண்ணீர்",
      rm: "Thanneer",
      en: "Water",
    },
    {
      ta: "சாப்பாடு",
      rm: "Saappaadu",
      en: "Food",
    },
    {
      ta: "டீ",
      rm: "Tee",
      en: "Tea",
    },
    {
      ta: "காபி",
      rm: "Kaapi",
      en: "Coffee",
    },
    {
      ta: "பீர்",
      rm: "Beer",
      en: "Beer",
    },
    {
      ta: "மது",
      rm: "Madhu",
      en: "Alcohol",
    },
    {
      ta: "சைவம்",
      rm: "Saivam",
      en: "Vegetarian",
    },
    {
      ta: "அசைவம்",
      rm: "Asaivam",
      en: "Non-vegetarian",
    },
    {
      ta: "இது சைவமா?",
      rm: "Idhu saivamaa?",
      en: "Is this vegetarian?",
    },
    {
      ta: "எனக்கு பசிக்குது",
      rm: "Enakku pasikkuthu",
      en: "I am hungry",
    },
    {
      ta: "எனக்கு தாகமா இருக்கு",
      rm: "Enakku thaagamaa irukku",
      en: "I am thirsty",
    },
    {
      ta: "எவ்வளவு நேரம் ஆகும்?",
      rm: "Evvalavu neram aagum?",
      en: "How much time will it take?",
    },
    {
      ta: "பாஸ்போர்ட்",
      rm: "Passport",
      en: "Passport",
    },
    {
      ta: "விசா",
      rm: "Visa",
      en: "Visa",
    },
    {
      ta: "டிக்கெட்",
      rm: "Ticket",
      en: "Ticket",
    },
    {
      ta: "ஹோட்டல்",
      rm: "Hotel",
      en: "Hotel",
    },
    {
      ta: "ரூம்",
      rm: "Room",
      en: "Room",
    },
    {
      ta: "நான் ஒரு ரூம் புக் பண்ணனும்",
      rm: "Naan oru room book pannnanum",
      en: "I want to book a room",
    },
    {
      ta: "இது ரொம்ப நல்லா இருக்கு",
      rm: "Idhu romba nalla irukku",
      en: "This is very good",
    },
    {
      ta: "இது ரொம்ப மோசமா இருக்கு",
      rm: "Idhu romba mosamaa irukku",
      en: "This is very bad",
    },
    {
      ta: "ஒன்னும் பிரச்சனை இல்ல",
      rm: "Onnum pirachchanai illa",
      en: "No problem",
    },
    {
      ta: "வாழ்த்துக்கள்",
      rm: "Vaazhththukkal",
      en: "Best wishes / Congratulations",
    },
    {
      ta: "ஜாலியா இருங்க",
      rm: "Jaaliyaa irunga",
      en: "Have fun",
    },
    {
      ta: "சாப்பிடுங்க",
      rm: "Saapidunga",
      en: "Please eat (formal)",
    },
    {
      ta: "சாப்பிடு",
      rm: "Saapidu",
      en: "Eat (informal)",
    },
    {
      ta: "வாங்க",
      rm: "Vaanga",
      en: "Come (formal)/ Please come",
    },
    {
      ta: "வா",
      rm: "Vaa",
      en: "Come (informal)",
    },
    {
      ta: "உட்காருங்க",
      rm: "Utkaarunga",
      en: "Please sit (formal)",
    },
    {
      ta: "உட்காரு",
      rm: "Utkaaru",
      en: "Sit (informal)",
    },
    {
      ta: "கொஞ்சம் இடம் கொடுங்க",
      rm: "Konjam idam kodunga",
      en: "Please give some space",
    },
    {
      ta: "வேகமா போங்க",
      rm: "Vegamaa ponga",
      en: "Go fast",
    },
    {
      ta: "புதுசா இருக்கு",
      rm: "Pudhusa irukku",
      en: "It's new",
    },
    {
      ta: "பழசா இருக்கு",
      rm: "Pazhasa irukku",
      en: "It's old",
    },
  ],
};
